import { render, staticRenderFns } from "./addnotes.html?vue&type=template&id=bc154ed0&external"
import script from "./addnotes.vue?vue&type=script&lang=js"
export * from "./addnotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports